// src/components/TopMenu.js
import React, { useContext } from 'react';
import { Button, IconButton, Tooltip } from '@material-ui/core';
import HomeIcon from '@material-ui/icons/Home';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import logo from './../rcrm_logo.png';
import { useHistory } from 'react-router-dom';
import { AuthContext } from './AuthContext';

const TopMenu = ({ showHome, showLogout }) => {
  const history = useHistory();
  const { logout } = useContext(AuthContext);
  return (
    <header
      className="top-menu"
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: 60,
        background: '#fff',
        boxShadow: '0 2px 8px rgba(0,0,0,0.07)',
        zIndex: 1200,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '0 32px',
        borderBottom: '1px solid #e5e7eb',
        boxSizing: 'border-box',
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <img src={logo} alt="logo" style={{ maxHeight: 38, marginRight: 14 }} />
      </div>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        {showHome && (
          <Button
            variant="contained"
            color="primary"
            startIcon={<HomeIcon />}
            onClick={() => history.push('/admin-dashboard')}
            style={{
              backgroundColor: '#1976d2',
              color: 'white',
              fontWeight: 600,
              marginRight: 16,
              padding: '7px 18px',
              borderRadius: 6,
              boxShadow: '0 1px 4px rgba(25,118,210,0.08)',
              textTransform: 'none',
              fontSize: 16,
              display: 'flex',
              alignItems: 'center',
              gap: 8
            }}
          >
            Home
          </Button>
        )}
        {showLogout && (
          <Button
            variant="contained"
            className="menu-button logout-button"
            onClick={logout}
            startIcon={<ExitToAppIcon />}
            style={{ backgroundColor: '#dc3545', color: 'white', fontWeight: 600, marginLeft: 8, padding: '7px 18px', boxShadow: '0 1px 4px rgba(220,53,69,0.08)', borderRadius: 6, textTransform: 'none', fontSize: 16, display: 'flex', alignItems: 'center', gap: 8 }}
          >
            Logout
          </Button>
        )}
      </div>
    </header>
  );
};

export default TopMenu;
